var rmUtil = require("../rmlibrary_old/util");
var PDFPage = require("./page");
var PDFNode = require("./node");

var allTemplates = {};

function PDFPageContent() {
    PDFNode.apply(this, arguments);
}
rmUtil.inherits(PDFPageContent, PDFNode);

PDFPageContent.prototype.generate = function(pdf) {
    return pdf.sectionContent({
        verticalAlign: this.computedStyles.verticalAlign,
        verticalAlignFirst: this.computedStyles.verticalAlignFirst,
    });
};

function PDFPageTemplate(children, attributes) {
    PDFPage.apply(this, arguments);

    this.id = attributes.id;

    if (this.id) allTemplates[this.id] = this;
}
rmUtil.inherits(PDFPageTemplate, PDFPage);

PDFPageTemplate.PageContent = PDFPageContent;
PDFPageTemplate.getById = function(id) {
    return allTemplates[id];
};

PDFPageTemplate.prototype.generate = function(pdf) {
    return this.getBlock(pdf);
};

module.exports = PDFPageTemplate;
